import $ from 'jquery'
window.$ = window.jQuery = $

import modal from  'jquery-modal'
import select2 from 'select2'
import datepicker from '@chenfengyuan/datepicker'
import '@chenfengyuan/datepicker/i18n/datepicker.es-ES.js'

$.ajaxSetup({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
  }
});

$(document).ready(function() {
    $('nav li.active a.subcategory').addClass('expanded');
    $('nav li.active ul').slideDown();

    $('.subcategory').click(function(e) {
        e.preventDefault();
        $(this).next().slideToggle();
        $(this).toggleClass('expanded');
    });

    $('#collapse').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('collapsed');
        $('nav').toggleClass('closed');
        $('main').toggleClass('fullwidth');
        $(window).trigger('collapse-menu');
    });

    $('.ac-delete').click(function(e) {
        e.preventDefault();
        var modalDelete = $('#modal-delete');
        modalDelete.find('form').attr('action', $(this).attr('href'));
        modalDelete.modal({
            fadeDuration: 250,
            fadeDelay: 0.8
        });
    });

    $('select:not(.searchable)').select2({
        width: 'resolve',
        minimumResultsForSearch: -1
    });

    $('select.searchable').select2({
        width: 'resolve'
    });

    $('.datepicker').datepicker({
        language: 'es-ES',
        autoHide: true,
        format: 'dd-mm-yyyy'
    });

    // TableSearch
    $('.search input').each(function() {
        var table = $('#'+$(this).data('table'));
        var searchRows = table.find('tbody tr');
        var searchString = null;
        var content = null;

        $(this).keyup(function() {
            searchString = $(this).val().toLowerCase();

            searchRows.each(function() {
                var cells = $(this).children('td.searchable');
                var matched = false;

                cells.each(function(index, cell) {
                    content = stripHtml(cell.innerHTML);
                    if (content.indexOf(searchString) != -1) {
                        matched = true;
                    }
                });

                if (!matched) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });

        });
    });
});

function showMessage(message, type) {
    var content = '<div id="message" class="'+type+'">'+message+'</div>';

    $('body').append(content);

    $('#message').animate({top: 0}, 800, function() {
        $(this).delay(5000).animate({top: -60}, 500, function() {
            $(this).remove();
        })
    });
}

window.showMessage = showMessage

function stripHtml(html) {
    var output = html.replace(new RegExp('<[^<]+\>', 'g'), "");
    output = $.trim(output.toLowerCase());
    return output;
}

window.stripHtml = stripHtml;



// WEBPACK FOOTER //
// ./resources/assets/admin.js